export default "__VITE_ASSET__f61fe1e9__"